import request from 'superagent'
import types from '../types'
import Dropdown from '../../types/Dropdown'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
const apiUrl = api_port==='' ? `${protocol}//${hostname}/api` : `${protocol}//${hostname}:${api_port}/api`

const getEthnicityRequested = () => ({
  type: types.GET_ETHNICITY_REQUESTED,
  payload: null
})

const getEthnicityRejected = (error: any) => ({
  type: types.GET_ETHNICITY_REJECTED,
  payload: error
})

const getEthnicityFulfilled = (data: Array<Dropdown>) => ({
  type: types.GET_ETHNICITY_FULFILLED,
  payload: data
})

export const getEthnicity = (token: string) => {
  return (dispatch: any) => {
    dispatch(getEthnicityRequested())

    request
      .get(`${apiUrl}/ethnicities`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getEthnicityFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getEthnicityRejected(error))
      })
  }
}